<template>
  <div class="py-5 icon-slider">
    <ul>
      <li v-for="image in images" :key="image">
        <MovingIcon :icon="image" limit />
      </li>
    </ul>
  </div>
</template>

<script>
import MovingIcon from "./Custom/MovingIcon.vue";

export default {
  data() {
    return {
      images: [
        "applemusic",
        "spotify",
        "discord",
        "pandora",
        "youtube",
        "tidal",
        "applemusic",
        "spotify",
        "discord",
        "pandora",
        "youtube",
        "tidal",
        "applemusic",
        "spotify",
        "discord",
        "pandora",
        "youtube",
        "tidal",
        "applemusic",
        "spotify",
        "discord",
        "pandora",
        "youtube",
        "tidal",
        "applemusic",
        "spotify",
        "discord",
        "pandora",
        "youtube",
        "tidal",
      ],
    };
  },
  components: { MovingIcon },
};
</script>

<style>
.icon-slider {
  width: 2179px;
  margin: auto;
  overflow: visible;
}
.icon-slider ul {
  display: flex;
  padding: 0;
  animation: cambio 80s infinite ease-in-out;
}
.icon-slider li {
  padding: 0 10px;
  list-style: none;
}
.icon-slider img {
  max-width: fit-content !important;
  height: auto !important;
}
@keyframes cambio {
  from {
    margin-left: 0%;
  }
  to {
    margin-left: -100%;
  }
}
</style>
